import { Info } from 'lucide-react';
import { cn } from '@/lib/utils';

interface BannerInfoProps {
    className?: string;
    desc?: string;
}

const BannerInfo = ({ className, desc }: BannerInfoProps) => {
    return (
        <div className={cn('w-full p-3 text-white gap-3 rounded-[12px] bg-text-blue-100 inline-flex items-start', className)}>
            <Info size={24} />
            <p className='reg12 lg:text-[16px]'>{desc}</p>
        </div>
    )
}


export default BannerInfo